import moment from 'moment';
import { Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Spinner } from '@treams/treams-ui';

import TalentReview from './TalentReview';

export default function TalentReviewSnapshotPage(props: { snapshotID: string }) {
	const query = graphql.useTalentReviewSnapshotQuery({
		variables: { id: props.snapshotID },
	});

	const snapshot = query.data?.talentReviewSnapshot;

	if (!snapshot) {
		return (
			<Flex my={5} justifyContent="center">
				<Spinner />
			</Flex>
		);
	}

	return (
		<TalentReview
			embedded
			templateID={snapshot.template.id}
			groupID={snapshot.group.id}
			localDate={snapshot.localDate}
			grid={
				{
					localDate: snapshot.localDate,
					viewerCanUpdate: false,
					template: snapshot.template,
					group: snapshot.group,
					placements: snapshot.placements,
					activity: snapshot.activity,
				} as graphql.TalentReviewGrid
			}
			snapshot={{
				id: snapshot.id,
				title: snapshot.title,
				description: snapshot.description ?? undefined,
				visibility: snapshot.visibility,
				submittedAt: moment(snapshot.createdAt).format('LL'),
				submittedBy: `${snapshot.createdBy.firstName} ${snapshot.createdBy.lastName}`,
				localDate: moment(snapshot.localDate).format('LL'),
				viewerCanCorrect: snapshot.viewerCanCorrect,
				activity: snapshot.activity,
			}}
		/>
	);
}
